var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_c('b',[_vm._v("Order #:")]),_vm._v(" "+_vm._s(_vm.order.orderNumber))]),_c('v-list-item-subtitle',[_vm._v("Account: "+_vm._s(_vm.order.firstName)+" "+_vm._s(_vm.order.lastName))]),_c('v-list-item-subtitle',[_vm._v("Email: "+_vm._s(_vm.order.email))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }